module.exports = __webpack_public_path__ + "static/media/14_2.a238003d.png";